import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Constant } from '../../../environments/constants';
import { Utils } from '../../../utils/utils';
import { Subscription } from 'rxjs';
import { ContextService } from '../../services/context/context.service';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { AccountsService } from '../../services/accounts.service';
import { ExternalAccountService } from '../../services/external-account.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import * as fromModel from '../../services/models';

import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';

@Component({
  selector: 'gp-liability-list',
  templateUrl: './liability-list.component.html',
  styleUrls: ['./liability-list.component.scss']
})
export class LliabilityListComponent implements OnInit, OnDestroy, OnChanges {

  protected _storeDataSubscription: Subscription;
  @Input('SaveId') saveId: string;
  @Input('ListType') listType: string = 'AST'; //LB or AST or blank
  //@Output() onSave: EventEmitter<any> = new EventEmitter();
  
  Liabilities: any = [];
  SelectedLiabilities: any = [];
  displayedColumns: string[] = ['select', 'id', 'taxstatus', 'modelName', 'actions', 'AccountKPIs.AccountTotal'];
  dataSource = new MatTableDataSource<any>(this.Liabilities);
  selection = new SelectionModel<any>(true, []);

  clientMenuItems = [];
  
  isDataChanged = false;
  constructor(private accountsService: AccountsService,
    private externalAccountService: ExternalAccountService,
    private contextService:ContextService,
    private dataService:DataService,
    private uiStateService: UIStateService,
    private appMonitoringService: AppMonitoringService) {      
    }

  ngOnInit(): void {
    if(this.contextService.context.Account && this.contextService.context.Account.length>0){
      this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "LliabilityListComponent-ngOnInit", true);
    }
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   
    let clients: fromModel.PlanClient[] = this.dataService.getPlanClients();
    if(clients && clients.length>0){
      clients.forEach(cl => {
        this.clientMenuItems.push({clientid: cl.clientid, displayClientname: `${cl.clientname}`});    
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    //this.save();    
  }

  private populateAppData(appData: fromModel.IAppData){
    if(appData && appData.action!==fromModel.DATA_ACTION.NONE){
      this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "LliabilityListComponent-populateAppData", true);
      if(this.dataService.appData.Accounts 
        && this.dataService.appData.Accounts["value"] 
        && this.dataService.appData.Accounts["value"].length>0){    
          this.Liabilities = this.dataService.appData.Accounts["value"].filter(val=>val.registrationtype==='LB');
          this.SelectedLiabilities = [];
          this.Liabilities.forEach(acc => {
            const selectedAccount = this.contextService.context.SelectedLiabilities.find(actNo=>actNo === acc.id);
            if(selectedAccount){
              this.SelectedLiabilities.push(acc);
            }
        });
        this.dataSource = new MatTableDataSource<any>(this.Liabilities);
        this.selection = new SelectionModel<any>(true, this.SelectedLiabilities);          
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "LliabilityListComponent-populateAppData", false);
      } else if(this.dataService.appData.Accounts && this.dataService.appData.Accounts["Error"]) {  

        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG, "LliabilityListComponent-populateAppData", {ShowMsg: true, MsgType: fromModel.MSGTYPE.ERROR, Msg: Constant.ErrorMsgs.systemErrorMsg});        
      }
      //this.populateHypotheticalAccList();
    }
  }

  populateHypotheticalAccList(){

    let ExternalAccounts: any = [];
    let allAccounts: any = [];
       
    if(this.dataService.appData.ExternalAccounts 
      && this.dataService.appData.ExternalAccounts["accounts"] 
      && this.dataService.appData.ExternalAccounts["accounts"].length>0){  

        this.dataService.appData.ExternalAccounts["accounts"].forEach(acc => {
          const tempAcc = this.Liabilities.find(_acc=>_acc.id === acc.id);
          if(tempAcc){
            const posTempAcc = this.Liabilities.indexOf(tempAcc);
            this.Liabilities.splice(posTempAcc,1);
            //do nothing - account is already there in the list
          } 

          let eaData = {
            custodianType: fromModel.CUSTODIANTYPE.HypoEA,  
            id: acc.id,
            accounttype: acc.actTypeDesc,
            LegalEntityName: this.dataService.getPlanClientByClientId(acc.clientid)?this.dataService.getPlanClientByClientId(acc.clientid).clientname:acc.clientname,
            legalEnityId: acc.clientid,
            //eaBase: acc.eaBase,
            AccountKPIs: {AccountTotal: acc.mktValue},
            mktValue: acc.mktValue,
            accountNickname: acc.name,
            shortName: acc.name,
            taxstatus: Utils.getTaxStatusDisplayName(acc.taxstatus),
            modelName:''
          };

          ExternalAccounts.push(eaData);
          const selectedExternalAccount = this.contextService.context.SelectedExternalAccounts.find(accID=>accID === acc.id);
          if(selectedExternalAccount && selectedExternalAccount.length>0){
            const _acc = this.SelectedLiabilities.find(ac=>ac.id === eaData.id);
            if(_acc){ 
              const pos =  this.SelectedLiabilities.indexOf(_acc);
              if(pos > -1){
                this.SelectedLiabilities.splice(pos, 1);                        
              }
            }
            this.SelectedLiabilities.push(eaData);
          }            
        });

        let sortBy = [
          {
            prop: 'custodianType',
            direction: 1,
            number: false
          },
          {
            prop: "mktValue",
            direction: -1,
            number: true
          }
        ];
        Utils.multiplesort(ExternalAccounts, sortBy);          


        this.Liabilities.forEach(element => {
          allAccounts.push(element);
          
        });
        
        ExternalAccounts.forEach(element => {
          allAccounts.push(element);
          
        });
        this.dataSource = new MatTableDataSource<any>(allAccounts);
        this.selection = new SelectionModel<any>(true, this.SelectedLiabilities);
      }      
  }

  masterToggle() {
    if(this.dataSource && this.dataSource.data && this.dataSource.data.length){
      this.isDataChanged = true;
      this.isAllSelected() ?
          this.selection.clear() :
          this.dataSource.data.forEach(row => this.selection.select(row));
    }
  }

  selectionToggle(row){
    this.isDataChanged = true;
    this.selection.toggle(row);    
  }

  isAllSelected() {
    if(this.dataSource && this.dataSource.data && this.dataSource.data.length){
      const numSelected = this.selection.selected.length;
      const numRows = this.dataSource.data.length;
      return numSelected === numRows;
    }
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  changeAccountSelection(event, row){
    event? this.selection.toggle(row) : null;
    this.updateSelectedAccountInLocalcache();        
  } 

  changeAllAccountSelection(event){
    event ? this.masterToggle() : null;
    this.updateSelectedAccountInLocalcache();    
  }

  saveSelectedAccounts() {
    this.updateSelectedAccountInLocalcache();
    this.dataService.savePlan();
    this.isDataChanged = false;
  }

  updateSelectedAccountInLocalcache(){
    let selectedLiabilities = [];
      let selectedEALiabilities = [];
      this.selection.selected.forEach(s => {
        if(s.custodianType === fromModel.CUSTODIANTYPE.HypoEA){
          selectedEALiabilities.push(s.id);
        } else {
          selectedLiabilities.push(s.id);
        }
      });
      this.contextService.dispatchAction(fromModel.APP_ACTION.SELECTEDLIABILITIES, "LliabilityListComponent-updateSelectedAccountInLocalcache", {selectedLiabilities: selectedLiabilities, selectedEALiabilities: selectedEALiabilities});    
      this.dataService.dispatchAction(fromModel.DATA_ACTION.SELECTEDPLANLIABILITIES, "LliabilityListComponent-updateSelectedAccountInLocalcache", {selectedLiabilities: selectedLiabilities, selectedEALiabilities: selectedEALiabilities});
  }

  refresh(){
    this.dataService.dispatchAction(fromModel.DATA_ACTION.EXTERNALACCOUNTS, "LliabilityListComponent-refresh", null);    
    this.dataService.getExternalAccountListByClientIds();
    this.populateHypotheticalAccList();
  }

  addHypotheticalAccount(clientid){
    window.open(Constant.uri.createEA + clientid, 'eawindow');
  }

  editHypotheticalAccount(eaid, clientid){
    window.open(`${Constant.uri.editEA}${eaid}?cid=${clientid}`, 'eawindow');
  }
    

  ngOnDestroy(): void{
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }        
  }
}
